import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { getCustomers } from "apis/CustomersApis";
import { logout } from "actions/auth";
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Select } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { propTypes } from 'react-bootstrap/esm/Image';

const { primary, secondary, text, transparent } = colors;
const { size } = typography;

const SearchCustomer = ({ handleChange, selectedCustomer, onCustDataListFetch, refreshTrigger }) => {
    const Token = useSelector(state => state.accessToken);
    const [localCustomerDataList, setLocalCustomerDataList] = React.useState([]);
    const dispatch = useDispatch();
    const history = useHistory();
    // const [selectedCustomer, setSelectedCustomer] = useState({});

    const getCustomerData = () => {
        return new Promise(function (resolve, reject) {
            getCustomers().then((response) => {
                //setProcessing(false);
                setLocalCustomerDataList(response);
                resolve(response);
                // console.log("get all customer: ", response);
                onCustDataListFetch(response);

            }).catch((error) => {
                //setProcessing(false);
                setLocalCustomerDataList([]);
                let errMessage = '';

                if (error.response) {
                    errMessage = error.response.data.message;
                    if (error.response.status === 401 || error.response.status === 403) {
                        // <Redirect from="/" to="/login" />
                        let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
                        dispatch(logout(jsonPostMsg));
                        history.push('/login');
                    }
                } else if (error.request) {
                    errMessage = `${error}`;
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                    errMessage = error.message;
                }
                reject(errMessage);
            });
        });
    };

    React.useEffect(() => {
        getCustomerData();
    }, [refreshTrigger]);

    return (
        <React.Fragment>
            <Box sx={{ width: "50%", marginBottom: 2, display: "flex", alignItems: "center", gap: 2 }}>
                <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 600, marginBottom: '8px', whiteSpace: "nowrap" }}>
                    Search Customer Name :
                </Typography>
                <Select
                    id="customerId"
                    name="customerId"
                    value={selectedCustomer.org_name}
                    onChange={handleChange}
                    displayEmpty
                    fullWidth
                    sx={{
                        '.MuiSelect-select': {
                            paddingTop: '8px !important',
                            paddingBottom: '8px !important',
                            minHeight: '35px !important',
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '1em !important'
                        }
                    }}
                >
                    {localCustomerDataList.map((customer) => (
                        <MenuItem key={customer.customer_id} value={customer.org_name}>
                            {customer.org_name}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
        </React.Fragment>
    )
}

export default SearchCustomer
